import { useState, useEffect } from "react";
import "../styles/Modal.css";
import { supportedTranslationLanguages } from "../constants/letureLanguages";

// 언어 설정 모달 컴포넌트
const LanguageSettingsModal = ({
  isOpen,
  onClose,
  targetLanguages,
  onSave,
}: {
  isOpen: boolean;
  onClose: () => void;
  targetLanguages: string[];
  onSave: (languages: string[]) => void;
}) => {
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>([]);

  // 모달 스크롤 방지 효과
  useEffect(() => {
    if (isOpen) {
      // 스크롤 위치 저장
      const scrollY = window.scrollY;

      // body에 modal-open 클래스 추가
      document.body.classList.add("modal-open");

      // 스크롤 위치 설정
      document.body.style.top = `-${scrollY}px`;

      // 정리 함수
      return () => {
        document.body.classList.remove("modal-open");
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  // 모달이 열릴 때마다 언어 설정 초기화
  useEffect(() => {
    if (isOpen) {
      // 최대 6개 언어만 선택 가능하도록 제한
      const limitedLanguages = targetLanguages.slice(0, 6);
      setSelectedLanguages(limitedLanguages);

      // 제한된 경우 경고 메시지 표시
      if (limitedLanguages.length !== targetLanguages.length) {
        setTimeout(() => {
          alert(
            `최대 6개 언어까지 선택 가능합니다. 처음 6개 언어만 선택됩니다.`
          );
        }, 300);
      }
    }
  }, [isOpen, targetLanguages]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(selectedLanguages);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>번역 언어 설정</h3>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="settings-content">
            <p>번역할 언어를 선택해주세요 (최대 6개)</p>
            <div className="language-checkboxes">
              {supportedTranslationLanguages
                .filter((lang) => lang.code !== "ko-KR")
                .map((lang) => (
                  <label key={lang.code} className="language-checkbox">
                    <input
                      type="checkbox"
                      value={lang.code}
                      checked={selectedLanguages.includes(lang.code)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          // 최대 6개 언어만 선택 가능
                          if (selectedLanguages.length < 6) {
                            setSelectedLanguages((prev) => [
                              ...prev,
                              lang.code,
                            ]);
                          } else {
                            alert("최대 6개 언어까지 선택 가능합니다.");
                            e.preventDefault(); // 체크 방지
                          }
                        } else {
                          setSelectedLanguages((prev) =>
                            prev.filter((code) => code !== lang.code)
                          );
                        }
                      }}
                    />
                    <span>
                      {lang.koreanName} ({lang.nativeName})
                    </span>
                  </label>
                ))}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            취소
          </button>
          <button className="btn-primary" onClick={handleSave}>
            저장
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSettingsModal;
